import systemService from './system.service'
import httpService from './http.service'
const project = require('/public/static/project.json')

const userService = function() {

    const userStorageName = `tw_${project.project_id}_user`
    const user = localStorage[userStorageName] && JSON.parse(localStorage[userStorageName]) || {}

    const powersStorageName = `tw_${project.project_id}_powers`
    let powers = localStorage[powersStorageName] && JSON.parse(localStorage[powersStorageName]) || []

    const routesStorageName = `tw_${project.project_id}_routes`
    let routes = localStorage[routesStorageName] && JSON.parse(localStorage[routesStorageName]) || []

    function setUserState(obj) {
        Object.assign(user, obj)
        localStorage[userStorageName] = JSON.stringify(user)
    }

    function setPowersState(arr) {
        // 将原来树形结构的菜单数据扁平化方便查询
        const getMenus = function(menus) {
            const result = []
            for (let i = 0; i < menus.length; i++) {
                const menu = menus[i];
                result.push(menu)
                
                if (menu.children?.length) {
                    const subMenus = getMenus(menu.children)
                    result.push(...subMenus)
                }
            }
            return result
        }

        /* 使用 routes.json 和 menus.json 两个文件主要是因为
         * routes.json 只用于记录每个页面的路由名称以及是否需要权限控制（包含所有页面）
         * menus.json 只包含功能维护定义的页面，由于有些页面并不需要在功能维护中定义，但又需要打开，所以需要 routes.json 中的定义
         */

        // 路由数据是由页面数据变化时生成
        const routeDatas = require('/public/static/routes.json')
        // 菜单数据是由功能维护生成
        const menuDatas = require('/public/static/menus.json')
        // 由于权限使用的是菜单ID，而路由是页面ID，所以需要通过 menus.json 关联查询
        let menus = getMenus(menuDatas)
        // 过滤有权限的菜单项
        menus = menus.filter(el => arr.indexOf(el.id) >= 0)
        // 获取不需要权限控制的路由和用户有权限的路由
        routes = routeDatas.filter(el => el.without_power || menus.find(menu => menu.file_name === el.name))
        // 保存提供刷新时可以获取路由
        localStorage[routesStorageName] = JSON.stringify(routes)

        powers = arr
        localStorage[powersStorageName] = JSON.stringify(arr)
    }

    // 用户登录
    function userLogin(info) {
        const optLogin = { name: 'login', headers: { Authorization: ''  } }
        return httpService.post(optLogin, {}, info).then(user => {
            return loginSob(user.token, info.sob_no)
        })
    }

    function loginSob(token, sobNo) {
        return new Promise((resolve, reject) => {
            // 进入账套
            const data = { app_no: project.project_id }
            // 如果参数中指定了要登录的账套则登录该账套，否则登录默认账套
            if (sobNo) {
                data['sob_no'] = sobNo
            }
            const optLoginSob = { name: 'login-sob', headers: { Authorization: `Bearer ${token}`  } }
            httpService.post(optLoginSob, {}, data).then(userSob => {
                // 将用户信息存到本地存储
                setUserState(Object.assign({}, userSob))

                // 加载路由及权限
                httpService.get('user-powers').then(userPowers => {
                    setPowersState(userPowers)
                    resolve(userSob.token)
                })
            }).catch(err => {
                reject(err)
            })
        })
    }

    var pub = {
        // 用户登录（不传 sobNo 时登录默认账套）
        login(userNo, password, sobNo) {
            const info = { mode: 1, user_no: userNo, password: password, sob_no: sobNo }
            return userLogin(info)
        },

        // 微信登录（不传 sobNo 时登录默认账套）
        loginForCode(code, sobNo) {
            // 微信浏览器登录时 mode 为3（即公众平台的公众号appid），微信扫码登录时 mode 为 2（即开放平台的网站应用appid）
            const mode = systemService.isWeixinBrowser ? 3 : 2
            // 需要传递 project_id，后台用于区别 appid，不同项目可能使用的不一样
            const info = { mode: mode, app_no: systemService.project_id, code: code, sob_no: sobNo }
            return userLogin(info)
        },

        // 令牌登录（不传 sobNo 时登录默认账套）
        loginForToken(token, sobNo) {
            return loginSob(token, sobNo)
        },

        // 退出
        logout() {
            setUserState({ token: '', expires_in: '' })
            setPowersState([])
        },

        // 发送验证码
        sendCheckCode(userNo) {
            const optSendCheckCode = { name: 'send-check-code', headers: { Authorization: ''  } }
            return httpService.post(optSendCheckCode, {}, {
                user_no: userNo
            })
        },

        // 重置密码
        resetPassword(userNo, password, code) {
            const optResetPassword = { name: 'reset-password', headers: { Authorization: ''  } }
            return httpService.post(optResetPassword, {}, {
                user_no: userNo,
                password: password,
                code: code
            })
        },

        // 获取用户名（如果有的话）
        get userNo() {
            return user.user_no || ''
        },

        // 是否已登录
        get isLogin() {
            if (user.expires_in) {
                var today = new Date();
                if (Date.parse(user.expires_in) - Date.parse(today) >= 0) {
                    return true; 
                }
            }
            return false
        },

        get user() {
            return user
        },

        isPower(id) {
            return powers.indexOf(id) !== -1
        },

        getPropertyValue(name, defaultValue) {
            return httpService.get('user-profile', { property_name: name }).then(result => {
                return result?.property_value ?? defaultValue
            })
        },

        setPropertyValue(name, value) {
            return httpService.put('user-profile', { property_name: name }, { property_value: value })
        },

        // 用户有权限的路由
        get routes() {
            return routes
        }
    }

    return pub;
}

var service = userService();

export default service;